import React, { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import DynamicForm from "../../../data/Axios/DynamicForm";
import {
  generateAndExecuteMutation,
  graphqlQuery,
} from "../../../data/Axios/DynamicService";

import { companyManagementUrl, salesManagement } from "../../../config";


const base_url = salesManagement.uri;

const SalesOrderForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);
const formatDate = (date) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const initialValues = {
  saleDate: props.data
    ? formatDate(props.data.saleDate)
    : formatDate(new Date()),
};

 
 
  const fields = [
    {
      name: "saleDate",
      label: "SaleDate",
      type: "date",
      gridColumn: "span 2",
      required: true,
    },
  ];
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { saleDate } = values;
      const now = new Date();
      const currentTime = now.toTimeString().split(" ")[0]; // HH:MM:SS
      const todayDate = now.toISOString().split("T")[0];    // YYYY-MM-DD

      // const combinedDateTime = `${paymentDate}T00:00:00`;
      // If item.createdDate is missing, use today
      const safeCreatedDate = saleDate && saleDate.trim() !== ""
        ? saleDate
        : todayDate;

      const combinedDateTime = `${safeCreatedDate}T${currentTime}`;
      const mutationData = props.isEditing
        ? {
            id: props.data.saleOrderId,
            saleDate: combinedDateTime
          }
        : {
            saleDate,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateSaleDate" : " ",
        mutationData,
        props.isEditing ? "saleOrder" : " ",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Sale Order ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };
 
  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={
        props.isEditing
          ? "Edit Sale Order Items"
          : "Create Sale Order Items"
      }
      subtitle={
        props.isEditing
          ? "Edit an Existing Sale Order Items"
          : "Create a New Sale Order Items"
      }
    />
  );
};

export default SalesOrderForm;
